"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CDialog = _interopRequireDefault(require("01_core/components/materials/CDialog"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _InputFile = _interopRequireDefault(require("01_core/components/materials/InputFile"));
var _ListIconButton = _interopRequireDefault(require("01_core/components/materials/ListIconButton"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CustomRouter = require("01_core/components/system/CustomRouter");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _useRHFForm = require("01_core/validation/useRHFForm");
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 証跡登録部品
 * @prop {string} [buttonFlg] - ボタン切替用
 * @prop {string} [kansaTgtNendo] - 選択されている監査対象年度
 * @prop {string} [kansaTgtJigyoId] - 選択されている監査対象年度
 * @prop {string} [eviNo] - 選択されている証跡NO
 * @prop {string} [eviDocNm] - 選択されている証跡ドキュメント名
 * @prop {string} [eviFileNm] - 選択されている証跡ファイル名
 * @prop {func} onChange - 変更ハンドラ<br/>
 * シグネチャ:({trailDocName:string, trailFileNm:string})
 */
const BUTTON_MARGIN_LEFT = 15;
const CANCEL_BTN_MARGIN_RIGHT = 16;
const StyledGridItem = (0, _styles.styled)(_material.Grid)({
  flexGrow: 0
});
const StyledMarginButton = (0, _styles.styled)(_CButton.default)({
  marginLeft: BUTTON_MARGIN_LEFT
});
const StyledCardActions = (0, _styles.styled)(_material.CardActions)(_ref => {
  let {
    theme
  } = _ref;
  return {
    textAlign: 'right',
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2)
  };
});
const StyledFooter = (0, _styles.styled)('footer')({
  width: '100%',
  textAlign: 'right'
});
const StyledCancelButton = (0, _styles.styled)(_CButton.default)({
  marginRight: CANCEL_BTN_MARGIN_RIGHT
});
function KansaAnswerTrailEntry(props) {
  var _errors$trailFile, _errors$trailDocName;
  const {
    intl,
    buttonFlg,
    eviDocNm,
    eviFileNm,
    kansaTgtNendo,
    kansaTgtJigyoId,
    eviNo,
    openInfoBar,
    callAPIMultipart,
    onChange
  } = props;
  const [isDialogOpen, setIsDialogOpen] = (0, _react.useState)(false);
  const childRef = (0, _react.useRef)(null);

  // RHF＋Yup スキーマ
  const shape = (0, _react.useMemo)(() => {
    return {
      trailDocName: (0, _validationHelpers.requiredStringTrimMax)(intl, 100),
      // 新規登録時（buttonFlg=true）はファイル必須、更新時は任意
      trailFile: (0, _validationHelpers.requiredFileWhen)(intl, 'isCreate', is => is === true),
      isCreate: (0, _validationHelpers.optionalBoolean)()
    };
  }, [intl]);
  const defaultValues = (0, _react.useMemo)(() => ({
    trailDocName: eviDocNm === undefined ? '' : eviDocNm,
    trailFile: null,
    isCreate: !!buttonFlg
  }), [eviDocNm, buttonFlg]);
  const {
    handleSubmit,
    setValue,
    watch,
    formState,
    reset,
    clearErrors
  } = (0, _useRHFForm.useRHFForm)({
    defaultValues,
    shape
  });
  const {
    errors
  } = formState;
  const trailDocName = watch('trailDocName');

  /** ダイアログを開くイベント */
  const openDialog = (0, _react.useCallback)(() => {
    reset(defaultValues, {
      keepErrors: false,
      keepDirty: false,
      keepTouched: false,
      keepIsSubmitted: false
    });
    clearErrors();
    if (childRef.current) {
      childRef.current.reSet();
    }
    setIsDialogOpen(true);
  }, [reset, clearErrors, defaultValues]);

  /** ダイアログを閉じるイベント */
  const closeDialog = (0, _react.useCallback)(() => {
    setIsDialogOpen(false);
    // クローズ時もクリアしておく（次回オープンでの残留防止）
    reset(defaultValues, {
      keepErrors: false,
      keepDirty: false,
      keepTouched: false,
      keepIsSubmitted: false
    });
    clearErrors();
    setValue('trailFile', null, {
      shouldValidate: false,
      shouldDirty: false
    });
    if (childRef.current) {
      childRef.current.reSet();
    }
  }, [reset, clearErrors, setValue, defaultValues]);

  /** 選択ファイル変更イベント */
  const onChangeTrailFile = (0, _react.useCallback)(file => {
    setValue('trailFile', file, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [setValue]);

  /** 証跡名変更イベント */
  const onChangeTrailDocNm = (0, _react.useCallback)(value => {
    setValue('trailDocName', value, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [setValue]);

  /** 登録ボタン押下（onValid） */
  const onValid = (0, _react.useCallback)(values => {
    const {
      trailDocName: docName,
      trailFile: file
    } = values;
    const trailFileNm = (file === null || file === void 0 ? void 0 : file.name) || '';
    const sendData = new FormData();
    sendData.append('kansaTgtNendo', kansaTgtNendo);
    sendData.append('kansaTgtJigyoId', kansaTgtJigyoId);
    sendData.append('eviNo', eviNo === undefined ? '' : eviNo);
    sendData.append('eviDocNm', docName);
    sendData.append('fileNm', trailFileNm);
    sendData.append('file', file || '');
    const apiNm = file ? _APIs.KANSA_ANSWER_TRAIL_REGIST : _APIs.KANSA_ANSWER_TRAIL_UPDATE;
    callAPIMultipart(apiNm, sendData).then(response => {
      if (response.status !== _APIs.STATUS.SUCCESS) {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
        if (childRef.current) {
          childRef.current.reSet();
        }
        return;
      }
      onChange(docName);
      closeDialog();
    });
  }, [kansaTgtNendo, kansaTgtJigyoId, eviNo, callAPIMultipart, openInfoBar, onChange, closeDialog]);

  /** onInvalid */
  const onInvalid = (0, _react.useCallback)(() => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  }, [openInfoBar, intl]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(StyledGridItem, null, buttonFlg && /*#__PURE__*/_react.default.createElement(StyledMarginButton, {
    autoWidth: true,
    onClick: openDialog
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_TRAIL_ADDED
  })), !buttonFlg && /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
    action: "update",
    onClick: openDialog
  }))), /*#__PURE__*/_react.default.createElement(_CDialog.default, {
    title: intl.formatMessage(eviDocNm === undefined ? {
      id: _labelConsts.LABEL.KANSA_TRAIL_REGISTER
    } : {
      id: _labelConsts.LABEL.KANSA_TRAIL_UPDATE
    }),
    open: isDialogOpen,
    handleClose: closeDialog
  }, /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(onValid, onInvalid)
  }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.DialogContent, null, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_FILE
    }),
    required: !!buttonFlg
  }, /*#__PURE__*/_react.default.createElement(_InputFile.default, {
    onRef: ref => childRef.current = ref,
    onChange: onChangeTrailFile,
    dispFileNm: eviFileNm,
    error: !!errors.trailFile,
    helperText: (_errors$trailFile = errors.trailFile) === null || _errors$trailFile === void 0 ? void 0 : _errors$trailFile.message
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_FILE_SELECT
  }))))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_TRAIL_NAME
    }),
    required: true
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: trailDocName,
    onChange: onChangeTrailDocNm,
    maxLength: 100,
    error: !!errors.trailDocName,
    helperText: (_errors$trailDocName = errors.trailDocName) === null || _errors$trailDocName === void 0 ? void 0 : _errors$trailDocName.message
  }))))))), /*#__PURE__*/_react.default.createElement(_material.DialogActions, null, /*#__PURE__*/_react.default.createElement(StyledCardActions, null, /*#__PURE__*/_react.default.createElement(StyledFooter, null, /*#__PURE__*/_react.default.createElement(StyledCancelButton, {
    negative: true,
    onClick: () => {
      closeDialog();
    },
    autoWidth: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_CANCEL
  })), /*#__PURE__*/_react.default.createElement(_CButton.default, {
    submit: true
  }, intl.formatMessage(eviDocNm === undefined ? {
    id: _labelConsts.LABEL.CORE_REGISTER
  } : {
    id: _labelConsts.LABEL.CORE_UPDATE
  }))))))));
}
KansaAnswerTrailEntry.propTypes = {
  required: _propTypes.default.bool,
  validate: _propTypes.default.bool,
  label: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired
};
const mapStateToProps = state => {
  return {
    systemSettings: state.coreLoginInfo.systemSettings
  };
};
const mapDispatchToProps = dispatch => ({
  openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message))
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CustomRouter.withRouter)((0, _CallAPI.withCallAPI)(KansaAnswerTrailEntry))));